import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=2a5222f7&"
import script from "./PasswordResetView.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5222f7')) {
      api.createRecord('2a5222f7', component.options)
    } else {
      api.reload('2a5222f7', component.options)
    }
    module.hot.accept("./PasswordResetView.vue?vue&type=template&id=2a5222f7&", function () {
      api.rerender('2a5222f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/PasswordResetView.vue"
export default component.exports